<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

const {
  icon = undefined,
} = defineProps<{
  icon?: IconDefinition;
}>();

const attrs = useAttrs();
</script>

<template>
  <p-message
    v-bind="attrs"
    :pt-options="{ mergeProps: true }"
  >
    <template #icon>
      <fa-icon
        v-if="icon"
        :icon
        size="lg"
        data-test="message-icon"
      />
    </template>

    <slot />
  </p-message>
</template>
